/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Favorites Manager is a module for managing favorites lists and items
define('modules/Favorites/FavoritesManager',[
    'jquery',
    'global/all',
    'modules/User/Users',
    'modules/Upcharges/UpchargeRegistrationService',
    'plugins/magnific-popup'
], function ($, Roc, Users, UpchargeRegistrationService) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var productToAdd = null;

    function getGroupId() {
        return $('#hdnGroupId').val();
    }

    function bindCancelCreateListEvt() {
        $(document).on('click', '#cancelCreateListBtn', function () {
            productToAdd = null;

            // close currently open modal
            Roc.UI.Modal.close();
        });
    }

    function addList(data) {
        $.ajax({
            type: 'PUT',
            url: apiUrl + '/api/favorites/list',
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'
        }).done(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.ADD_LIST, $.extend({}, { 'Result': true }, response));
        }).fail(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.ADD_LIST, $.extend({}, { 'Result': false }, response));
        });
    }

    function addItem(productId, listId, qty, groupId, uomId, upchargesData) {
        var requestData = {
            'ProductId': productId,
            'ListId': listId,
            'Quantity': qty,
            'UomId': uomId
        };

        if (groupId) {
            requestData.groupId = groupId;
        }

        if (upchargesData) {
            requestData.upchargeData = {};

            _.each(upchargesData, function (value, key) {
                var request = {
                    code: value.code,
                    upchargeAmount: value.upchargeAmount,
                    json: value.json,
                };

                if ($.type(request.json) !== "string") {
                    request.json = JSON.stringify(request.json);
                }

                requestData.upchargeData[key] = request;
            });
        }

        $.ajax({
            type: 'POST',
            url: apiUrl + '/api/favorites/item',
            data: JSON.stringify(requestData),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'
        }).done(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.ADD_ITEM, $.extend({}, { 'Result': true }, response));
        }).fail(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.ADD_ITEM, $.extend({}, { 'Result': false, 'productId': productId }, response));
        });
    }
    //BEGIN CUSTOMIZATION
    function getUomId(productId) {
        //Custom code to support addToCart from listing page 
        var uomSelector = '.selectedUom[data-roc-productId=' + productId + ']';
        return $(uomSelector).val() || null;
    }
     //END CUSTOMIZATION
    function bindSaveCreateListEvt() {
        $(document).on('click', '#createNewListInlineBtn', function () {
            var $popupHtml = $.magnificPopup.instance.content;
            var requestData = {
                'Privacy': parseInt($popupHtml.find('select#privacy').val()),
                'Name': $popupHtml.find('input#favoritesName').val()
            }
            if (requestData.Name.length === 0) {
                Roc.UI.warning('Please enter a list name');
            }
            else {
                if (/^\s+$/i.test(requestData.Name)) {
                    Roc.UI.warning('Name is not valid');
                } else {
                    if (productToAdd !== null) {
                        var upchargeData = {};

                        // populate upcharge data for any registered upcharges
                        UpchargeRegistrationService.populateUpchargeData(upchargeData);

                        $.ajax({
                            type: 'PUT',
                            url: apiUrl + '/api/favorites/list',
                            data: JSON.stringify(requestData),
                            contentType: 'application/json; charset=utf-8',
                            dataType: 'json'
                        })
                            .done(function (response) {
                                Roc.EventManager.notify(Roc.Events.favorites.ADD_LIST,
                                    $.extend({}, { 'Result': true }, response));
                                 //BEGIN CUSTOMIZATION: to get product uom
                                var UomId = getUomId(productToAdd);
                                addItem(productToAdd, response.id, 1, getGroupId(), UomId, upchargeData);
                                 //END CUSTOMIZATION
                                productToAdd = null;

                                // close currently open modal
                                Roc.UI.Modal.close();
                            })
                            .fail(function (response) {
                                // close currently open modal
                                Roc.UI.Modal.close();

                                Roc.UI
                                    .displayErrorPopup('There was an error while trying to create a new list. Please try again.');
                            });
                    } else {
                        addList(requestData);

                        // close currently open modal
                        Roc.UI.Modal.close();
                    }
                }
            }
        });
    }

    function bindEvents() {
        bindCancelCreateListEvt();
        bindSaveCreateListEvt();
    }

    function addListAndMoveItem(productId) {
        if (typeof productId !== 'undefined') {
            productToAdd = productId;
        }

        Roc.UI.template('favoritesList-Tmp', {
            'createList': true,
            'createButtonId': 'createNewListInlineBtn'
        }).then(function (renderedTemplate) {
            Roc.UI.Modal.open(renderedTemplate);
        });
    }
    function updateList(data) {
        $.ajax({
            type: 'POST',
            url: apiUrl + '/api/favorites/list',
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8'
        }).done(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.UPDATE_LIST, $.extend({}, { 'Result': true }, response));
        }).fail(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.UPDATE_LIST, $.extend({}, { 'Result': false }, response));
        });
    }

    function moveItem(movedItem) {        
        var requestData = {
            'FromListId': movedItem.fromListId,
            'Id': movedItem.itemId,
            'UomId': movedItem.uomId,
            'ToListId': movedItem.toListId
        };

        $.ajax({
            type: 'POST',
            url: apiUrl + '/api/favorites/moveitem',
            data: JSON.stringify(requestData),
            contentType: 'application/json; charset=utf-8'
        }).done(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.MOVE_ITEM, $.extend({}, { 'Result': true }, movedItem));
        }).fail(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.MOVE_ITEM, $.extend({}, { 'Result': false }, movedItem));
        });
    }

    function deleteList(id) {
        var requestData = { 'id': id };
        $.ajax({
            type: 'DELETE',
            url: apiUrl + '/api/favorites/list/' + id,
            contentType: 'application/json; charset=utf-8'
        }).done(function () {
            Roc.EventManager.notify(Roc.Events.favorites.DELETE_LIST, $.extend({}, { 'Result': true }, requestData));
        }).fail(function (resonse) {
            Roc.EventManager.notify(Roc.Events.favorites.DELETE_LIST, $.extend({}, { 'Result': false }, requestData));
        });
    }

    function updateItem(item) {
        $.ajax({
            type: 'POST',
            url: apiUrl + '/api/favorites/item',
            data: JSON.stringify(item),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'
        }).done(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.UPDATE_ITEM, $.extend({}, { 'Result': true }, response));
        }).fail(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.UPDATE_ITEM, $.extend({}, { 'Result': false }, response));
        });
    }

    function deleteItem(deletedItem) {
        var requestData = {
            'Id': deletedItem.itemId,
            'ListId': deletedItem.listId
        }
        $.ajax({
            type: 'DELETE',
            url: apiUrl + '/api/favorites/item',
            data: JSON.stringify(requestData),
            contentType: 'application/json; charset=utf-8'
        }).done(function () {
            Roc.EventManager.notify(Roc.Events.favorites.DELETE_ITEM, $.extend({}, { 'Result': true }, deletedItem));
        }).fail(function () {
            Roc.EventManager.notify(Roc.Events.favorites.DELETE_ITEM, $.extend({}, { 'Result': false }, deletedItem));
        });
    }

    function getItem(id) {
        $.ajax({
            type: 'GET',
            url: apiUrl + '/api/favorites/item/' + id,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        }).done(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.GET_ITEM, $.extend({}, { 'Result': true }, response));
        }).fail(function () {
            Roc.EventManager.notify(Roc.Events.favorites.GET_ITEM, $.extend({}, { 'Result': false }, { 'Id': id }));
        });
    }

    function getList(id, includeItems) {
        if (typeof includeItems === 'undefined') {
            includeItems = false;
        }

        $.ajax({
            type: 'GET',
            url: apiUrl + '/api/favorites/list/' + id,
            data: JSON.stringify({ 'includeItems': includeItems }),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        }).done(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.GET_LIST, $.extend({}, { 'Result': true }, response));
        }).fail(function () {
            Roc.EventManager.notify(Roc.Events.favorites.GET_LIST, $.extend({}, { 'Result': false }, { 'Id': id }));
        });
    }

    function addFriend(token) {
        $.ajax({
            type: 'PUT',
            url: apiUrl + '/api/favorites/friends',
            data: JSON.stringify({ "Token": token }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'
        }).done(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.ADD_FRIEND, $.extend({}, { 'Result': true }, response));
        }).fail(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.ADD_FRIEND, $.extend({}, { 'Result': false }, response));
        });
    }

    function deleteFriend(token) {
        $.ajax({
            type: 'DELETE',
            url: apiUrl + '/api/favorites/friends',
            data: JSON.stringify({ "Token": token }),
            contentType: 'application/json; charset=utf-8'
        }).done(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.DELETE_FRIEND, $.extend({}, { 'Result': true, 'token': token }, response));
        }).fail(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.DELETE_FRIEND, $.extend({}, { 'Result': false, 'token': token }, response));
        });
    }

    function updateProduct(favoritesItemId, productId, wantsQty, uomId) {
        $.ajax({
            type: 'POST',
            url: apiUrl + '/api/favorites/product',
            data: JSON.stringify({ 'FavoritesItemId': favoritesItemId, 'ProductId': productId, 'WantsQty': wantsQty, 'UomId': uomId }),
            contentType: 'application/json; charset=utf-8'
        }).done(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.UPDATE_PRODUCT, $.extend({}, { 'Result': true, }, response));
        }).fail(function (response) {
            Roc.EventManager.notify(Roc.Events.favorites.UPDATE_PRODUCT, $.extend({}, { 'Result': false }, response));
        });
    }

    function isProductSavedToFavorites(productId) {
        if (!Users.isLoggedIn()) {
            return $.Deferred().reject();
        }

        return $.ajax({
            type: 'GET',
            url: apiUrl + '/api/favorites/product/saved?productId=' + productId,
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('FavoritesManager -> isProductSavedToFavorites');
                Roc.Logger.info(xhr);
            }
        });
    }

    function init() {
        bindEvents();
    }

    var FavoritesManager = {
        addListAndMoveItem: addListAndMoveItem,
        addList: addList,
        updateList: updateList,
        moveItem: moveItem,
        deleteList: deleteList,
        addItem: addItem,
        updateItem: updateItem,
        deleteItem: deleteItem,
        getItem: getItem,
        getList: getList,
        addFriend: addFriend,
        deleteFriend: deleteFriend,
        updateProduct: updateProduct,
        isProductSavedToFavorites: isProductSavedToFavorites
    };

    init();

    Roc.Logger.debug('FavoritesManager.js Loaded:', FavoritesManager);

    return FavoritesManager;
});

